export default __webpack_public_path__ + "static/media/horse-slide3.f92058ab.png";